export default __webpack_public_path__ + "static/media/Livestock_bg.26758674.jpg";